import i18n from "i18next";
import {initReactI18next} from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            "home": "Home",
            "ln": "বাংলা",
            "featuredCourses": "Featured Courses",
            "pricing": "Pricing",
            "myCourse": "My Course",
            "contact": "Contact",
        }
    },
    bn: {
        translation: {
            "home": "হোম",
            "ln": "English",
            "featuredCourses": "বৈশিষ্ট্যযুক্ত কোর্স",
            "pricing": "মূল্য স্থির",
            "myCourse": "আমার কোর্স",
            "contact": "যোগাযোগ",
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;